export const DEFAULT_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 10,
  ordering: '-created',
};
